"use client";

import { useMemo } from "react";

import { tokenAddresses, tokens } from "#/config/web3/tokens";
import { BungeeToken } from "#/services/bridge/bridge.types";
import { useTokensList } from "#/services/bridge/hooks/useTokensList";
import { isEqualAddress } from "#/utils/isEqualAddress";

import { useChainId } from "./useChainId";
import { useUsdcBalance } from "./useUsdcBalance";

export const useUserTokensList = () => {
  const { chainId } = useChainId();
  const {
    usdcBalance,
    refetch: refetchUsdcBalance,
    isLoading: isUsdcBalanceLoading,
  } = useUsdcBalance();
  const {
    data: tokensList,
    isLoading: isTokensListLoading,
    refetch: refetchTokensList,
  } = useTokensList();

  const usdcToken: BungeeToken = {
    ...tokens.USDC,
    chainId,
    address: tokenAddresses.USDC[chainId],
    balance: isUsdcBalanceLoading ? undefined : usdcBalance.toString(),
  };

  const userHoldingTokens = useMemo(() => {
    if (!tokensList) {
      return [];
    }

    return tokensList.filter((token) => {
      if (
        token.chainId === chainId &&
        isEqualAddress(token.address, tokenAddresses.USDC[chainId])
      ) {
        return false;
      }
      const balanceNum = token.balance ? parseFloat(token.balance) : 0;
      return !isNaN(balanceNum) && balanceNum > 0;
    });
  }, [tokensList, chainId]);

  return {
    data: [usdcToken, ...userHoldingTokens],
    isLoading: isTokensListLoading,
    refetch: () => {
      refetchUsdcBalance();
      refetchTokensList();
    },
  };
};
